import { Navigate } from 'react-router-dom'
import { useAppSelector } from '@/app/hooks'
import { selectUser } from '@/features/auth/authSlice'
import { ApplicationDetail } from '@/features/application/pages/ApplicationDetail'
import { isLibertySalesRole } from '@/features/application/utils/applicationPolicies'

export function ApplicationDetailAccessGuard() {
  const user = useAppSelector(selectUser)

  if (isLibertySalesRole(user)) {
    return <Navigate to="/application" replace />
  }

  return <ApplicationDetail />
}
